// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";
import { atmosphereUboDeclarationWGSL } from "../ShadersWGSL/ShadersInclude/atmosphereUboDeclaration";
import { helperFunctionsWGSL } from "core/ShadersWGSL/ShadersInclude/helperFunctions";
import { intersectionFunctionsWGSL } from "core/ShadersWGSL/ShadersInclude/intersectionFunctions";
import { atmosphereFunctionsWGSL } from "../ShadersWGSL/ShadersInclude/atmosphereFunctions";

const name = "aerialPerspectivePixelShader";
const shader = `#define RENDER_CAMERA_VOLUME
#include<atmosphereUboDeclaration>
var transmittanceLutSampler: sampler;var transmittanceLut: texture_2d<f32>;var multiScatteringLutSampler: sampler;var multiScatteringLut: texture_2d<f32>;
#include<helperFunctions>
#include<atmosphereFunctions>
varying positionOnNearPlane: vec3f;uniform layerIdx: f32;@fragment
fn main(input: FragmentInputs)->FragmentOutputs {fragmentOutputs.color=renderCameraVolume(
input.positionOnNearPlane,
uniforms.layerIdx,
transmittanceLut,
multiScatteringLut
);}
`;
// Sideeffect
if (!ShaderStore.ShadersStoreWGSL[name]) {
    ShaderStore.ShadersStoreWGSL[name] = shader;
}
const includes = [atmosphereUboDeclarationWGSL, helperFunctionsWGSL, intersectionFunctionsWGSL, atmosphereFunctionsWGSL];
for (const inc of includes) {
    if (!ShaderStore.IncludesShadersStoreWGSL[inc.name]) {
        ShaderStore.IncludesShadersStoreWGSL[inc.name] = inc.shader;
    }
}

/** @internal */
export const aerialPerspectivePixelShaderWGSL = { name, shader };
